import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  BankWithdrawalDto,
  BankWithdrawalListDto,
  BankWithdrawalFilterDto,
  CreateBankWithdrawalRequest,
  UpdateBankWithdrawalRequest,
} from '@/types/bankWithdrawal.types';

export const bankWithdrawalApi = {
  /** GET /api/v1/bank-withdrawals — paginated list */
  getList: (filter?: BankWithdrawalFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<BankWithdrawalListDto>>>('/bank-withdrawals', { params: filter }),

  /** GET /api/v1/bank-withdrawals/{id} — full withdrawal detail */
  getById: (id: string) =>
    apiClient.get<ApiResponse<BankWithdrawalDto>>(`/bank-withdrawals/${id}`),

  /** POST /api/v1/bank-withdrawals — create new withdrawal (Draft) */
  create: (data: CreateBankWithdrawalRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/bank-withdrawals', data),

  /** PUT /api/v1/bank-withdrawals/{id} — update draft withdrawal */
  update: (id: string, data: UpdateBankWithdrawalRequest) =>
    apiClient.put<ApiResponse<object>>(`/bank-withdrawals/${id}`, data),

  /** POST /api/v1/bank-withdrawals/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-withdrawals/${id}/submit`),

  /** POST /api/v1/bank-withdrawals/{id}/approve — approve the withdrawal */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-withdrawals/${id}/approve`, { remarks }),

  /** POST /api/v1/bank-withdrawals/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-withdrawals/${id}/reject`, { reason }),

  /** POST /api/v1/bank-withdrawals/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-withdrawals/${id}/post`),

  /** POST /api/v1/bank-withdrawals/{id}/reverse — create reversal withdrawal */
  reverse: (id: string, reversalDate: string, reversalPostingDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/bank-withdrawals/${id}/reverse`, {
      reversalDate,
      reversalPostingDate,
      narration,
    }),

  /** POST /api/v1/bank-withdrawals/{id}/cancel — cancel the withdrawal */
  cancel: (id: string, reason?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-withdrawals/${id}/cancel`, { reason }),

  /** DELETE /api/v1/bank-withdrawals/{id} — soft-delete (draft only) */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/bank-withdrawals/${id}`),
};
